import type { BufferGeometry, Material, Texture } from "three/webgpu";

export class ResourceRegistry {
  private readonly geometries = new Set<BufferGeometry>();
  private readonly materials = new Set<Material>();
  private readonly textures = new Set<Texture>();

  geometry<T extends BufferGeometry>(resource: T): T {
    this.geometries.add(resource);
    return resource;
  }

  material<T extends Material>(resource: T): T {
    this.materials.add(resource);
    return resource;
  }

  texture<T extends Texture>(resource: T): T {
    this.textures.add(resource);
    return resource;
  }

  dispose() {
    for (const texture of this.textures) texture.dispose();
    for (const material of this.materials) material.dispose();
    for (const geometry of this.geometries) geometry.dispose();
    this.textures.clear();
    this.materials.clear();
    this.geometries.clear();
  }
}
